
import { commonfunc } from '@/mixin/common'
export default {
  name: 'BulkOrderStatus',
  components: {
  },
  mixins: [commonfunc],
  props: {
    selectMassStore: { // 대량배송 매장
      type: Object,
      default: () => {}
    }
  },
  computed: {
    massStoreKm () {
      let km = ''
      if (this.isNotEmpty(this.selectMassStore.km) && !this.isUnable) {
        km += ' '
        km += this.selectMassStore.km >= 1 ? this.selectMassStore.km.substr(0, this.selectMassStore.km.length - 2) + 'km' : (this.selectMassStore.km.substr(2, 1) > 0 ? this.selectMassStore.km.substr(2, 1) + '00' : this.selectMassStore.km.substr(2)) + 'm'
      }
      return km
    }
  },
  data () {
    return {
    }
  },
  methods: {
    openStoreInfo () {
      this.$emit('openStoreInfo')
    }
  },
}
